import { LinearProgress } from '@mui/material';

import { useLoadingStore } from '@/stores/loadingStore';

/**
 * Global loading bar shown at the top of the screen when any request is in flight.
 * Mounted once at the App root (above the AppBar).
 */
export function GlobalLoadingBar(): JSX.Element | null {
  const activeRequests = useLoadingStore((s) => s.activeRequests);

  if (activeRequests === 0) return null;

  return (
    <LinearProgress
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: (theme) => theme.zIndex.appBar + 1,
        height: 3,
      }}
    />
  );
}
